module.exports = __webpack_public_path__ + "static/media/finish-step-icon.6f1ad129.svg";